import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AdminAuthGuard } from "@/components/admin/admin-auth-guard";
import { MeAuthGuard } from "@/components/me/me-auth-guard";
import { AdminLayout } from "@/layouts/AdminLayout";
import { MeLayout } from "@/layouts/MeLayout";
import HomePage from "@/pages/HomePage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import DailyRegisterPage from "@/pages/admin/DailyRegisterPage";
import PeopleListPage from "@/pages/admin/PeopleListPage";
import PersonFormPage from "@/pages/admin/PersonFormPage";
import NoticesInboxPage from "@/pages/admin/NoticesInboxPage";
import AdminMantrasPage from "@/pages/admin/AdminMantrasPage";
import MonthlyAttendancePage from "@/pages/admin/MonthlyAttendancePage";
import WeeklyAttendancePage from "@/pages/admin/WeeklyAttendancePage";
import EmployeeShiftsPage from "@/pages/admin/EmployeeShiftsPage";
import HolidaysPage from "@/pages/admin/HolidaysPage";
import SyncDevicesPage from "@/pages/admin/SyncDevicesPage";
import MeLoginPage from "@/pages/me/MeLoginPage";
import MeTodayPage from "@/pages/me/MeTodayPage";
import MeNoticePage from "@/pages/me/MeNoticePage";
import MeMantrasPage from "@/pages/me/MeMantrasPage";
import MeHistoryPage from "@/pages/me/MeHistoryPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route element={<AdminAuthGuard />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="register" element={<DailyRegisterPage />} />
            <Route path="weekly" element={<WeeklyAttendancePage />} />
            <Route path="monthly" element={<MonthlyAttendancePage />} />
            <Route path="shifts" element={<EmployeeShiftsPage />} />
            <Route path="holidays" element={<HolidaysPage />} />
            <Route path="people" element={<PeopleListPage />} />
            <Route path="people/:id" element={<PersonFormPage />} />
            <Route path="notices" element={<NoticesInboxPage />} />
            <Route path="mantras" element={<AdminMantrasPage />} />
            <Route path="sync" element={<SyncDevicesPage />} />
          </Route>
        </Route>

        <Route path="/me/login" element={<MeLoginPage />} />
        <Route element={<MeAuthGuard />}>
          <Route path="/me" element={<MeLayout />}>
            <Route index element={<MeTodayPage />} />
            <Route path="notice" element={<MeNoticePage />} />
            <Route path="mantras" element={<MeMantrasPage />} />
            <Route path="history" element={<MeHistoryPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
